import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m20.893 13.398-1.135-1.135a2.3 2.3 0 0 1-.421-.585l-1.08-2.16a.414.414 0 0 0-.663-.108.83.83 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.391c.59.394.674 1.23.172 1.732l-.2.2c-.212.211-.33.497-.33.796v.41c0 .408-.11.808-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025A1.055 1.055 0 0 1 10.5 17.7v-1.172c0-.92-.56-1.747-1.414-2.09l-.655-.26a2.25 2.25 0 0 1-1.383-2.46l.007-.042a2.3 2.3 0 0 1 .29-.788l.09-.149a2.25 2.25 0 0 1 2.37-1.048l1.178.235a1.125 1.125 0 0 0 1.302-.794l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.09a2.25 2.25 0 0 1-1.591.66h-.18a.94.94 0 0 0-.662.274.931.931 0 0 1-1.458-1.137l1.41-2.352a2.3 2.3 0 0 0 .286-.76m11.928 9.869q.106-.682.107-1.393A9 9 0 0 0 8.965 3.529m11.928 9.869A9 9 0 1 1 8.965 3.53"
    }, null, -1)
  ])))
}
export default { render: render }